import { useContext, useEffect, useState } from "react";
import "./more-company-info.scss";
import { SignupContext } from "../../providers/signupProvider";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/typed-hooks";
import {
  companyRegistrationSelector,
  registerCompanyInfo,
} from "../../../redux/reducers/company-registration/companyRegistrationSlice";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import { select } from "d3";
import { IKeyValuePairOption } from "../../models/interfaces";

interface ICompanyTenureOption {
  id: number;
  value: string;
  isActive?: boolean;
}


const MoreCompanyInfo: React.FC = () => {
  const [selectedCompanyDuration, setSelectedCompanyDuration] =
    useState<number>();
  const [yearsInOperation, setYearsInOperation] = useState<string>("");
  const [businessSize, setBusinessSize] = useState<string | undefined>("");
  const [businessType, setBusinessType] = useState<string | undefined>("");
  const [mainServices, setMainServices] = useState<string | undefined>("");
  const [mainCustomer, setMainCustomer] = useState<string | undefined>("");
  const [revenueGenService, setRevenueGenService] = useState<string | undefined>("");
  const [customerTypeDetails, setCustomerTypeDetails] = useState<string | undefined>("");
  
  const { setCurrentStep } = useContext(SignupContext);
  const navigate = useNavigate();
  const selectCompnayInfo = useAppSelector(companyRegistrationSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    console.log(
      "Company registration information after filling company name and website url",
      selectCompnayInfo
    );
    setYearsInOperation(selectCompnayInfo.YearsInOperation);
    setBusinessSize(selectCompnayInfo.businessSize);
    setBusinessType(selectCompnayInfo.businessType);
    setMainServices(selectCompnayInfo.mainServices);
    setMainCustomer(selectCompnayInfo.mainCustomer);
    setRevenueGenService(selectCompnayInfo.revenueGenService);
    setCustomerTypeDetails(selectCompnayInfo.customerTypeDetails);
   

    if (
      companyRunningPeriodOptions &&
      companyRunningPeriodOptions.length &&
      selectCompnayInfo.YearsInOperation
    ) {
      const runningPeriod = companyRunningPeriodOptions.find(
        (runningP) => runningP.value == selectCompnayInfo.YearsInOperation
      );
      if (runningPeriod) {
        setSelectedCompanyDuration(runningPeriod.id);
      }
    }
  }, [selectCompnayInfo]);

  const GoToNextStage = (stage: string) => {
    if (yearsInOperation) {
      dispatch(
        registerCompanyInfo({
          ...selectCompnayInfo,
          YearsInOperation: yearsInOperation,
          businessSize: businessSize,
          businessType: businessType,
          mainServices: mainServices,
          mainCustomer: mainCustomer,
          revenueGenService: revenueGenService,
          customerTypeDetails: customerTypeDetails,

        })
      );
      setCurrentStep(stage);
      navigate("/signup-s3");
    } else {
      toast(
        "Please select the business operating duration to proceed to next page."
      );
    }
  };

  const GoBackToPrevStage = (stage: string) => {
    setCurrentStep(stage);
    navigate("/signup-s1");
  };

  const companyRunningPeriodOptions: ICompanyTenureOption[] = [
    {
      id: 1,
      value: "Less than 1 Year",
    },
    {
      id: 2,
      value: "1-3 Years",
    },
    {
      id: 3,
      value: "3-7 Years",
    },
    {
      id: 4,
      value: "Over 7 Years",
    },
  ];

  const businessSizeOptions: IKeyValuePairOption[] = [
    { key: 1, value: "Just me and a few others (1-10)" },
    { key: 2, value: "A growing team (11-50)" },
    { key: 3, value: "A bustling team (51-250)" },
    { key: 4, value: "Larger team (251+)" },
  ];

  const businessTypeOptions: IKeyValuePairOption[] = [
    { key: 1, value: "Retail (Fashion, Electronics, etc.)" },
    { key: 2, value: "Manufacturing (Consumer Goods, Machinery, etc.)" },
    { key: 3, value: "Technology (SaaS, Hardware, etc.)" },
    { key: 4, value: "Healthcare (Medical Devices, Services, etc.)" },
    { key: 5, value: "Services (Consulting, Financial, etc.)" },
    { key: 6, value: "Other (Please specify)" },
  ];

  const mainCustomerOptions: IKeyValuePairOption[] = [
    { key: 1, value: "Other businesses (B2B)" },
    { key: 2, value: "Individual consumers (B2C)" },
    { key: 3, value: "A mix of both" },
  ];

  const revenueGenServiceOptions: IKeyValuePairOption[] = [
    { key: 1, value: "Selling products" },
    { key: 2, value: "Providing services" },
    { key: 3, value: "Subscription-based revenue" },
    { key: 4, value: "Advertising" },
    { key: 5, value: "Other (Please specify)" },
  ];

  const onOptionSelected = (selectedOption: ICompanyTenureOption) => {
    console.log(selectedOption);
    companyRunningPeriodOptions.forEach((opt) => (opt.isActive = false));
    setSelectedCompanyDuration(selectedOption.id);
    setYearsInOperation(selectedOption.value);
  };

  const FORM_FIELDS = {
    BUSINESS_SIZE: "BusinessSize",
    BUSINESS_TYPE: "BusinessType",
    MAIN_SERVICES: "MainServices",
    MAIN_CUSTOMERS: "MainCustomers",
    REVENUE_GEN_SERVICE: "RevenueGenService",
    CUSTOMER_TYPE_DETAILS: "CustomerTypeDetails",
    USAGE_OF_TECH_IN_BUSINESS: "UsageOfTechInBusiness",

  };

  const onTextValueChanged = (
    value: string | undefined,
    optionType: string
  ) => {
    switch (optionType) {
      case FORM_FIELDS.MAIN_SERVICES:
        setMainServices(value);
        break;
        case FORM_FIELDS.CUSTOMER_TYPE_DETAILS:
        setCustomerTypeDetails(value);
        break;
    }
  };

  const onFormOptionSelectionChanged = (
    selectedOption: IKeyValuePairOption,
    optionType: string
  ) => {
    switch (optionType) {
      case FORM_FIELDS.BUSINESS_SIZE:
        setBusinessSize(selectedOption.value);
        break;
      case FORM_FIELDS.BUSINESS_TYPE:
        if (selectedOption.value !== businessTypeOptions[5].value) {
          setBusinessType(selectedOption.value);
        } else {
          // User has selected other then what ever the value user enter in the text box need to be updated as business type
        }
        break;
      case FORM_FIELDS.MAIN_CUSTOMERS:
        setMainCustomer(selectedOption.value);
        break;
      case FORM_FIELDS.REVENUE_GEN_SERVICE:
        setRevenueGenService(selectedOption.value);
      break;
    }
  };

  return (
    <div className="more-company-info-wrapper">
      <div className="company-info-title">Let's confirm your company info</div>
      <div>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
        varius enim in eros.
      </div>

      {/* Business size */}
      <div className="company-info-box">
        <div className="question-text">
          Let’s start simple! How many full-time team members are on your team?
        </div>
        <div className="question-options">
          {businessSizeOptions.map(
            (val: IKeyValuePairOption, index: number) => {
              return (
                <div
                  key={index}
                  className={`question-option ${
                    val.value == businessSize ? " active" : ""
                  }`}
                  onClick={() => {
                    onFormOptionSelectionChanged(
                      val,
                      FORM_FIELDS.BUSINESS_SIZE
                    );
                  }}
                >
                  {val.value}
                </div>
              );
            }
          )}
        </div>
      </div>

      {/* Business type */}
      <div className="company-info-box">
        <div className="question-text">
          Every business has its strengths! Which industry or niche do you
          operate in?
        </div>
        <div className="question-options">
          {businessTypeOptions.map(
            (val: IKeyValuePairOption, index: number) => {
              return (
                <div
                  key={index}
                  className={`question-option ${
                    val.value == businessType ? " active" : ""
                  }`}
                  onClick={() => {
                    onFormOptionSelectionChanged(
                      val,
                      FORM_FIELDS.BUSINESS_TYPE
                    );
                  }}
                >
                  {val.value}
                </div>
              );
            }
          )}
        </div>
      </div>

      {/* Company operation duration */}
      <div className="company-info-box">
        <div className="question-text">
          How long has your business been operating ?
        </div>
        <div className="question-options">
          {companyRunningPeriodOptions.map(
            (val: ICompanyTenureOption, index: number) => {
              return (
                <div
                  key={index}
                  className={`question-option ${
                    val.id == selectedCompanyDuration ? " active" : ""
                  }`}
                  onClick={() => {
                    onOptionSelected(val);
                  }}
                >
                  {val.value}
                </div>
              );
            }
          )}
        </div>
      </div>

      {/* Main services */}
      <div className="company-info-box">
        <div className="question-text">
          What products or services keep your customers coming back?
        </div>
        <div className="question-options">
          {
            <Form.Control
              as="textarea"
              value={mainServices}
              onChange={(event) => {
                onTextValueChanged(
                  event?.target.value,
                  FORM_FIELDS.MAIN_SERVICES
                );
              }}
            />
          }
        </div>
      </div>

      {/* Main customer */}
      <div className="company-info-box">
        <div className="question-text">Who do you serve the most?</div>
        <div className="question-options">
          {mainCustomerOptions.map(
            (val: IKeyValuePairOption, index: number) => {
              return (
                <div
                  key={index}
                  className={`question-option ${
                    val.value == mainCustomer ? " active" : ""
                  }`}
                  onClick={() => {
                    onFormOptionSelectionChanged(
                      val,
                      FORM_FIELDS.MAIN_CUSTOMERS
                    );
                  }}
                >
                  {val.value}
                </div>
              );
            }
          )}
        </div>
      </div>

      {/* Details of customer types */}
      <div className="company-info-box">
        <div className="question-text">
            Describe your customer types in detail [Optional]
        </div>
        <div className="question-options">
          {
            <Form.Control
              as="textarea"
              value={customerTypeDetails}
              onChange={(event) => {
                onTextValueChanged(
                  event?.target.value,
                  FORM_FIELDS.CUSTOMER_TYPE_DETAILS
                );
              }}
            />
          }
        </div>
      </div>

     {/* Main Revenue */}
      <div className="company-info-box">
        <div className="question-text">What are your primary sources of revenue?</div>
        <div className="question-options">
          {revenueGenServiceOptions.map(
            (val: IKeyValuePairOption, index: number) => {
              return (
                <div
                  key={index}
                  className={`question-option ${
                    val.value == revenueGenService ? " active" : ""
                  }`}
                  onClick={() => {
                    onFormOptionSelectionChanged(
                      val,
                      FORM_FIELDS.REVENUE_GEN_SERVICE
                    );
                  }}
                >
                  {val.value}
                </div>
              );
            }
          )}
        </div>
      </div>

      <div className="wizard-footer">
        <div>Step 2/4</div>
        <div className="wizard-footer__buttons">
          <div
            className="wizard-button"
            onClick={() => {
              GoBackToPrevStage("BASIC");
            }}
          >
            Back
          </div>
          <div
            className="wizard-button primary-button"
            onClick={() => {
              GoToNextStage("COMPANY_MORE");
            }}
          >
            Next
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoreCompanyInfo;
